import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Events from './pages/Events';
import Sermons from './pages/Sermons';
import Ministries from './pages/Ministries';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Donation from './pages/Donation';
import AdminLogin from './pages/AdminLogin';
import AdminLeadership from './pages/AdminLeadership';
import AdminEvents from './pages/AdminEvents';
import AdminSermons from './pages/AdminSermons';
import AdminMinistries from './pages/AdminMinistries';
import AdminGallery from './pages/AdminGallery';
import AdminAnnouncements from './pages/AdminAnnouncements';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-wrapper">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/ministries" element={<Ministries />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/donation" element={<Donation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gestion-ecclesiale/login" element={<AdminLogin />} />
            <Route path="/gestion-ecclesiale" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/gestion-ecclesiale/leadership" element={<ProtectedRoute><AdminLeadership /></ProtectedRoute>} />
            <Route path="/gestion-ecclesiale/events" element={<ProtectedRoute><AdminEvents /></ProtectedRoute>} />
            <Route path="/gestion-ecclesiale/sermons" element={<ProtectedRoute><AdminSermons /></ProtectedRoute>} />
            <Route path="/gestion-ecclesiale/ministries" element={<ProtectedRoute><AdminMinistries /></ProtectedRoute>} />
            <Route path="/gestion-ecclesiale/gallery" element={<ProtectedRoute><AdminGallery /></ProtectedRoute>} />
            <Route path="/gestion-ecclesiale/announcements" element={<ProtectedRoute><AdminAnnouncements /></ProtectedRoute>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
